import { useFeatureFlagValue } from "@mirage/service-experimentation/useFeatureFlagValue";

export const useCompanyOSIntegrationVariant = (): string => {
  return useFeatureFlagValue(
    "companyos_2025_03_06_dash_companyos_integration",
  ) as string;
};
